import Grid from '@material-ui/core/Grid'
import Search from 'Components/Search'
import Select from 'Components/Select'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import React, { useState } from 'react'

const invoiceStatus = [{
  label: 'Brouillon',
  value: 'draft'
}, {
  label: 'À régler',
  value: 'due'
}, {
  label: 'Paiement Partiel',
  value: 'payinprogress'
}, {
  label: 'Payée',
  value: 'paid'
}, {
  label: 'Retard',
  value: 'late'
}, {
  label: 'Annulée',
  value: 'cancelled'
},]

const proformaStatus = [{
  label: 'Brouillon',
  value: 'draft'
}, {
  label: 'Envoyée',
  value: 'sent'
}, {
  label: 'Lu',
  value: 'read'
}, {
  label: 'Acceptée',
  value: 'accepted'
}, {
  label: 'Expirée',
  value: 'expired'
}, {
  label: 'Acompte',
  value: 'advanced'
}, {
  label: 'Partiellement facturée',
  value: 'partialinvoiced'
}, {
  label: 'Facturée',
  value: 'invoiced'
}, {
  label: 'Annulée',
  value: 'cancelled'
},]

const orderStatus = [{
  label: 'Brouillon',
  value: 'draft'
}, {
  label: 'Envoyé',
  value: 'sent'
}, {
  label: 'Lu',
  value: 'read'
}, {
  label: 'Accepté',
  value: 'accepted'
}, {
  label: 'Expiré',
  value: 'expired'
}, {
  label: 'Acompte',
  value: 'advanced'
}, {
  label: 'Partiellement facturé',
  value: 'partialinvoiced'
}, {
  label: 'Facturé',
  value: 'invoiced'
}, {
  label: 'Annulé',
  value: 'cancelled'
},]

const deliveryStatus = [{
  label: 'Brouillon',
  value: 'draft'
}, {
  label: 'Envoyé',
  value: 'sent'
}, {
  label: 'Lu',
  value: 'read'
}, {
  label: 'Partiellement facturé',
  value: 'partialinvoiced'
}, {
  label: 'Facturé',
  value: 'invoiced'
}]

const creditnoteStatus = [{
  label: 'Brouillon',
  value: 'draft'
}, {
  label: 'À solder',
  value: 'stored'
}, {
  label: 'Partiel',
  value: 'partielspend'
}, {
  label: 'Soldé',
  value: 'spent'
}, {
  label: 'Annulé',
  value: 'cancelled'
}]

const estimateStatus = [{
  label: 'Brouillon',
  value: 'draft'
}, {
  label: 'Envoyé',
  value: 'sent'
}, {
  label: 'Lu',
  value: 'read'
}, {
  label: 'Accepté',
  value: 'accepted'
}, {
  label: 'Refusé',
  value: 'refused'
}, {
  label: 'Expiré',
  value: 'expired'
}, {
  label: 'Acompte',
  value: 'advanced'
}, {
  label: 'Partiellement facturé',
  value: 'partialinvoiced'
}, {
  label: 'Facturé',
  value: 'invoiced'
}, {
  label: 'Annulé',
  value: 'cancelled'
},]

const options = {
  estimate: estimateStatus,
  invoice: invoiceStatus,
  creditnote: creditnoteStatus,
  proforma: proformaStatus,
  order: orderStatus,
  delivery: deliveryStatus
}

export default React.memo(props => <Search limit={10} all raz={true} defaultSearch={props.defaultSearch} group_by={props.group_by}
  path={'interface/sellsy'} requete={Constants.donnee.document} module={Constants.module.SELLSY}
                                           search={props.search || ((props.searchName || 'cas_' ) + (props.name || '') + User.Entite.get().id)}>
    <SearchForm/>
  </Search>
)

const SearchForm = React.memo(props => {
  const [search, setSearch] = useState(props.search || {})
  const searching = (data, name) => {
    const srh = {
      ...(search || {}),
      [name]: data
    }
    setSearch(srh)
    props.searching && props.searching(srh)
  }

  return (
    <Grid container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
          alignItems={'stretch'}
          alignContent={'flex-start'}
          direction={'column'}>
      <Select title={EurestoI18n.t('crm:Type')} name="?type"
              onChange={searching}
              value={search['?type']}
              options={[{
                value: 'invoice',
                label: 'Facture'
              }, {
                value: 'estimate',
                label: 'Devis'
              }, {
                value: 'proforma',
                label: 'Facture Proforma'
              }, {
                value: 'delivery',
                label: 'Bon de livraison'
              }, {
                value: 'order',
                label: 'Bon de commande'
              }, {
                value: 'creditnote',
                label: 'Avoirs'
              }]}/>
      <Select title={EurestoI18n.t('crm:Status')} name="?status"
              onChange={searching}
              key={search['?type']}
              multiple
              value={search['?status']}
              options={search['?type'] && options[search['?type']] || []}/>
    </Grid>
  )
})


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Interface/Sellsy/Search.js